import React from "react";
import VersionHistoryBtn from "../../components/buttons/versionHistoryBtn";
import MainLayout from "../../components/layout/mainLayout/mainLayout";
import searcher from "../../assets/icons/searchInput.svg";
import CreateBtn from "../../components/buttons/createBtn";
import SuperUserListTable from "./super-user-list-table";
import { useLocation, useNavigate } from "react-router-dom";

const SuperUserList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParamsData = new URLSearchParams(location.search);
  const page_no = parseInt(queryParamsData.get("page") ?? 1);
  const search = queryParamsData.get("search") ?? "";
  return (
    <MainLayout breadCrumb="ADMIN / Super User">
      <div>
        <div className="search-container d-flex justify-content-between ">
          <div className="search-box w-50 d-flex align-items-center p-2 ms-3 m-1 mb-2">
            <img className="styled-SVG" src={searcher} color={""} />
            <input
              className="search-input fs_14 text-dark fw_400 px-2"
              type="text"
              value={search}
              placeholder="Search Super User here by Employee ID Name..."
              onChange={(e) =>
                navigate(
                  `/super-user/user?page=1${
                    e.target.value ? `&search=${e.target.value}` : ""
                  }`
                )
              }
            />
          </div>

          <div className=" d-flex justify-content-between m-1 mb-2">
            <VersionHistoryBtn link="/super-user/user/version-list" />
            <CreateBtn link="/super-user/user/create" />
          </div>
        </div>
        <SuperUserListTable search={search} page_no={page_no} />
      </div>
    </MainLayout>
  );
};

export default SuperUserList;
